// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"Overlay_Overlay__UwjAq","overlayPanel":"Overlay_overlayPanel__9C4oX","active":"Overlay_active__3PiuS","fadeIn":"Overlay_fadeIn__e9WF9","fadeOut":"Overlay_fadeOut__1KF3Z"};